import { auth } from "./context/auth/model";
import { configs } from "./context/configs/model";
import { dialogs } from "./context/dialogs/model";
import { branches } from "./context/branches/model";
import { cargillBranches } from "./context/cargill-branches/model";
import { notifications } from "./context/notifications/model";
import { farms } from "./context/farms/model";
import { navigation } from "./context/navigation/model";
import { users } from "./context/users/model";
import { timeBlocks } from "./context/time-blocks/model";
import { dates } from "./context/dates/model";
import { docks } from "./context/docks/model";
import { transporters } from "./context/transporters/model";
import { plants } from "./context/plants/model";
import { products } from "./context/products/model";
import { loadTypes } from "./context/load-types/model";
import { plantQuotas } from "./context/plant-quotas/model";
import { quotas } from "./context/quotas/model";
import { scheduling } from "./context/scheduling/model";
import { newScheduling } from "./context/new-scheduling/model";
import { driver } from "./context/driver/model";
import { loadingOrders } from "./context/loadingOrders/model";
import { clients } from "./context/clients/model";

export default {
  auth,
  loadingOrders,
  dialogs,
  notifications,
  branches,
  cargillBranches,
  farms,
  navigation,
  users,
  timeBlocks,
  dates,
  docks,
  transporters,
  plants,
  products,
  loadTypes,
  plantQuotas,
  quotas,
  scheduling,
  newScheduling,
  driver,
  clients,
  configs,
};
